module.exports = __webpack_public_path__ + "img/work_environment3.6944afc7.png";